import gql from 'graphql-tag';

import dokkioErrorFragment from './dokkioErrorFragment';

export const remoteItemShareRoleFragment = gql`
  fragment remoteItemShareRoleFragment on RemoteItemShareRole {
    dokkioClass
    role
    disabled
    disabledReason {
      ...dokkioErrorFragment
    }
  }
  ${dokkioErrorFragment}
`;

export default remoteItemShareRoleFragment;
